exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-slider img[data-v-ca868442] {\n  width: 100%;\n}\n", ""]);

// exports
